import React from "react";
import { TimePicker } from "@mui/x-date-pickers";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

import {
  Checkbox,
  FormControlLabel,
  Typography,
  FormHelperText,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { LoadingButton } from "@mui/lab";

function ChangeNotaryAvailability({
  formik,
  availabilities,
  availableNonstop,
  setAvailableNonstop,
  saveLoading,
  settings,
  readyChange,
  setReadyChange,
  changeErrorText,
  selectedDays,
  setSelectedDays,
  selectedStartTime,
  setSelectedStartTime,
  selectedEndTime,
  setSelectedEndTime,
  prefillLoading,
  handlePrefillTimes,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const maxLength = 100;
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const renderDayValues = (selected) => {
    if (!Array.isArray(selected)) {
      selected = [selected]; // Convert to an array if not already
    }

    if (selected.length === 0) {
      return <em>Select an option</em>;
    }

    // Join the selected items into a string
    const selectedText = selected.join(", ");

    // Truncate the text if it exceeds the maximum length
    const truncatedText =
      selectedText.length > maxLength
        ? selectedText.substring(0, maxLength) + "..."
        : selectedText;

    return truncatedText;
  };
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const findDay = (dayName) => {
    return (
      formik.values.availability.find((day) => day.day === dayName) || {
        day: dayName,
        available: false,
        startTime: null,
        endTime: null,
      }
    );
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      {/* START OF PRE FILL AVAILABILITIES  */}
      <Grid container justifyContent="center" mb={3}>
        <Grid size={{ xs: 12 }}>
          <Box
            sx={{
              border: "2px solid #f3f3f3",
              p: isMobile ? 2 : 3,
              borderRadius: "6px",
              boxShadow: "1px 3px 3px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: isMobile ? "1.1rem" : "1.25rem",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              Prefill Availabilities
            </Typography>
            <Grid container spacing={isMobile ? 1 : 2} mt={isMobile ? 2 : 3}>
              <Grid size={{ lg: 3, md: 12, sm: 12, xs: 12 }}>
                <FormControl fullWidth variant="filled">
                  <InputLabel id="role-label">Days</InputLabel>
                  <Select
                    disabled={prefillLoading || Boolean(availableNonstop)}
                    labelId="prefillAvailabilities"
                    multiple
                    onChange={(e) => setSelectedDays(e.target.value)}
                    label="Select Days"
                    value={selectedDays}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          marginTop: "1.5px",
                          maxHeight: 150, // Set the desired max height for the dropdown menu
                          width: "auto",
                          maxWidth: "100%",
                          "&& .Mui-selected": {
                            backgroundColor: "#E2E3E5",
                          },
                        },
                      },
                    }}
                    renderValue={renderDayValues}
                    sx={{
                      maxWidth: "100%", // Set the desired max-width for the input element
                      "& .MuiTypography-body2": {
                        whiteSpace: "wrap", // Prevent text from wrapping or shrinking
                      },
                      maxHeight: "10rem",
                    }}
                  >
                    {daysOfWeek.map(function (day, i) {
                      return (
                        <MenuItem key={i} value={day}>
                          <Typography variant="body2">{day}</Typography>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ lg: 3, md: 12, sm: 12, xs: 12 }}>
                <TimePicker
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                  }}
                  closeOnSelect={false}
                  sx={{
                    borderRadius: "10px",
                    width: isMediumScreen ? "100%" : "auto",
                  }}
                  label="Start Time"
                  disabled={prefillLoading || Boolean(availableNonstop)}
                  value={selectedStartTime}
                  minutesStep={30}
                  onChange={(value) => {
                    setSelectedStartTime(value ? value : null);
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, md: 12, sm: 12, xs: 12 }}>
                <TimePicker
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                  }}
                  closeOnSelect={false}
                  sx={{
                    borderRadius: "10px",
                    width: isMediumScreen ? "100%" : "auto",
                  }}
                  label="End Time"
                  disabled={
                    prefillLoading ||
                    (availabilities.length !== 0 && !settings) ||
                    Boolean(availableNonstop)
                  }
                  value={selectedEndTime}
                  minutesStep={30}
                  onChange={(value) => {
                    setSelectedEndTime(value ? value : null);
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, md: 12, sm: 12, xs: 12 }}>
                <LoadingButton
                  onClick={handlePrefillTimes}
                  loading={prefillLoading}
                  disabled={
                    !selectedStartTime ||
                    !selectedEndTime ||
                    Boolean(availableNonstop)
                  }
                  variant="contained"
                  color="primary"
                  size={isMediumScreen ? "small" : "large"}
                  fullWidth
                  sx={{
                    fontSize: isMobile ? "0.875rem" : "1rem",
                    py: isMobile ? 1 : 1.5,
                  }}
                >
                  P R E F I L L
                </LoadingButton>
              </Grid>
            </Grid>
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(availableNonstop)}
                    onChange={(event) => {
                      setReadyChange(false);
                      setAvailableNonstop(event.target.checked);
                    }}
                  />
                }
                label="Available 24/7"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      {/* END OF PRE FILL AVAILABILITIES  */}
      <Grid container spacing={isMobile ? 1 : 2}>
        {availableNonstop && (
          <Grid size={{ xs: 12 }}>
            <Typography align="center" color="text.secondary" sx={{ mb: 1 }}>
              24/7 mode is enabled. Daily time pickers are hidden and this
              notary will be treated as always available.
            </Typography>
          </Grid>
        )}
        {!availableNonstop &&
          daysOfWeek.map((day) => {
            const dayObj = findDay(day);
            const index = formik.values.availability.findIndex(
              (d) => d.day === day,
            );
            return (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={day}>
                <Box
                  sx={{
                    p: isMobile ? 1.5 : 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    backgroundColor: "#fafafa",
                    mb: 1,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formik.values.availability[index].available}
                        onChange={(event) => {
                          setReadyChange(false);
                          // Update the 'available' field
                          formik.setFieldValue(
                            `availability[${index}].available`,
                            event.target.checked,
                          );

                          // If unchecking, clear the TimePicker values
                          if (!event.target.checked) {
                            formik.setFieldValue(
                              `availability[${index}].startTime`,
                              null,
                            );
                            formik.setFieldValue(
                              `availability[${index}].endTime`,
                              null,
                            );
                          }
                        }}
                        name={`availability[${index}].available`}
                      />
                    }
                    label={day}
                  />
                  {dayObj?.available && (
                    <Box
                      sx={{
                        mt: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <TimePicker
                        viewRenderers={{
                          hours: renderTimeViewClock,
                          minutes: renderTimeViewClock,
                        }}
                        closeOnSelect={false}
                        sx={{
                          border: formik.errors.availability?.[index]?.startTime
                            ? "2px solid red"
                            : "",
                          borderRadius: "10px",
                          "& .MuiFormLabel-root": {
                            // Target the label
                            color: formik.errors.availability?.[index]
                              ?.startTime
                              ? "red"
                              : "",
                          },
                          "& .MuiInputBase-root": {
                            borderColor: formik.errors.availability?.[index]
                              ?.startTime
                              ? "red"
                              : "",
                          },
                          "& .MuiInputBase-root.Mui-error": {
                            "&::after": {
                              // Change underline color when error is present
                              borderBottomColor: "red",
                            },
                          },
                          // Add styles for placeholder if needed
                        }}
                        className={
                          formik.errors.availability?.[index]?.startTime
                            ? "error-timepicker"
                            : ""
                        }
                        label="Start Time"
                        value={dayObj.startTime}
                        minutesStep={30}
                        onChange={(value) => {
                          setReadyChange(false);
                          formik.setFieldValue(
                            `availability[${index}].startTime`,
                            value ? value : null,
                          );
                        }}
                      />
                      <FormHelperText sx={{ color: "error.main" }}>
                        {formik.errors.availability?.[index]?.startTime}
                      </FormHelperText>
                      <TimePicker
                        viewRenderers={{
                          hours: renderTimeViewClock,
                          minutes: renderTimeViewClock,
                        }}
                        closeOnSelect={false}
                        sx={{
                          border: formik.errors.availability?.[index]?.endTime
                            ? "2px solid red"
                            : "",
                          borderRadius: "10px",
                          "& .MuiFormLabel-root": {
                            // Target the label
                            color: formik.errors.availability?.[index]?.endTime
                              ? "red"
                              : "",
                          },
                          "& .MuiInputBase-root": {
                            borderColor: formik.errors.availability?.[index]
                              ?.endTime
                              ? "red"
                              : "",
                          },
                          "& .MuiInputBase-root.Mui-error": {
                            "&::after": {
                              // Change underline color when error is present
                              borderBottomColor: "red",
                            },
                          },
                          // Add styles for placeholder if needed
                        }}
                        className={
                          formik.errors.availability?.[index]?.endTime
                            ? "error-timepicker"
                            : ""
                        }
                        minutesStep={30}
                        label="End Time"
                        value={dayObj.endTime}
                        onChange={(value) => {
                          setReadyChange(false);
                          formik.setFieldValue(
                            `availability[${index}].endTime`,
                            value ? value : null,
                          );
                        }}
                      />
                      <FormHelperText sx={{ color: "error.main" }}>
                        {formik.errors.availability?.[index]?.endTime}
                      </FormHelperText>
                    </Box>
                  )}
                </Box>
              </Grid>
            );
          })}
        <Grid size={{ xs: 12 }}>
          <Typography color="error" fontWeight="bold" align="center">
            {typeof formik.errors?.availability === "string"
              ? formik.errors.availability
              : changeErrorText}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <LoadingButton
            disabled={readyChange}
            loading={saveLoading}
            fullWidth
            size={isMobile ? "medium" : "large"}
            variant="contained"
            type="submit"
            sx={{
              fontSize: isMobile ? "0.875rem" : "1rem",
              py: isMobile ? 1.5 : 2,
              mt: isMobile ? 2 : 3,
            }}
          >
            Change Availability
          </LoadingButton>
        </Grid>
      </Grid>
    </form>
  );
}

export default ChangeNotaryAvailability;
